module.exports = __webpack_public_path__ + "img/helmuth-oyarzun-final.88034edf.jpg";